const creditRequestTypes = {
  ARCHIVO_CARGANDO: "ARCHIVO_CARGANDO",
  ARCHIVO_CARGADO:"ARCHIVO_CARGADO",
  ARCHIVO_ERROR:"ARCHIVO_ERROR"
};

export default creditRequestTypes;